import { render, staticRenderFns } from "./LsmartERP.vue?vue&type=template&id=5549deec&scoped=true"
import script from "./LsmartERP.vue?vue&type=script&lang=js"
export * from "./LsmartERP.vue?vue&type=script&lang=js"
import style0 from "./LsmartERP.vue?vue&type=style&index=0&id=5549deec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5549deec",
  null
  
)

export default component.exports